export default {
  data(){
    return{
      prefix: 'drag-drawer'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/flow/components/dragDrawer/mixin.js